import { Component, OnInit } from '@angular/core';
import { LibraryService, Dropobj } from '../../services/library.service';
import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons, NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { AppGlobals } from '../../shared/app.global';

@Component({
  selector: 'app-bookresv',
  templateUrl: './bookresv.component.html',
  styleUrls: ['./bookresv.component.scss'],
  providers:[LibraryService],
})
export class BookresvComponent implements OnInit {
 
  private smallmodalRef: NgbModalRef;
  memberdetails:any[]=[];
  bookdetails:any[]=[];
  issuedetails:any[]=[];
  closeResult: string;
  modalOptions:NgbModalOptions;
  private modalRef: NgbModalRef;
  selitem:any={};
  selbook:any={};
  selmember:any={};
  dashcounts:any={};
  booksmodel:any={};
  oprtype:string='';
  objissued:any={};
  selres:string='return';
  selfine:string='Satisfactory';
  bkretstatus:string='';
  arrselbooks=[];
  arrresbooks=[];
   isLoadingResult: boolean;
   date1: any;
   dtissue:any;
   dtdue:any;
   isremarks:any;
   dueday:any='0';
   selstatus:any='returned';
   showisuemodal:boolean=false;
   fserdt:any;
     fserdt4:any;
     arrhis=[];
     selstat='returned';
     isrenewable:boolean=false;
     showfine:boolean=false;
     objretdata:any={};
     dtrec:any;
     objcopies:any={};
     objdet:any={};

   
  data = [
    {
      id: 1,
      name: 'Usa'
    },
    {
      id: 2,
      name: 'England'
    }
 ];
 statuses = [
  {value: 'Issued', label: 'Issued'},
  {value: 'Pending', label: 'Pending'},
  {value: 'Lapsed', label: 'Lapsed'},
  {value: 'Cancel', label: 'Cancel'},
];


  constructor(private http: HttpClient, private liservice: LibraryService,private modalService: NgbModal,private _global: AppGlobals) {

    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
     
    }
   }

   setfirstdate() {
    this.liservice.getsysdatetoday()
        .subscribe(
        resultArray => {
            console.log('getlibsource', resultArray);
            this.dtissue = resultArray;
            
            
        },
        error => console.log("Error :: " + error)
        )
  }
   open(content) {
    this.modalOptions = {
     
      size:'lg'
     
    }
    this.modalService.open(content, this.modalOptions ).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
 

  ngOnInit(): void {
    this.getlibtbkres();
  }


  Addbook()
  {
    
    //alert(this.selbooktitle+'-'+this.selbookid);
    var clid = 0;
    var subid = 0;
    var secid = 0;
    var retdt = '';
    var oprtype = '';
    if (this.oprtype=='insert')
    {

      oprtype = 'issuebook';
    }
    else
    {
      oprtype = 'update';
    }
   
    let clcd=localStorage.getItem('clcd');
    let aycd=localStorage.getItem('aycd');
    console.log('selbook-SAVE', this.selmember);
    console.log('selbook-SAVE', this.selbook);
    //.toISOString().slice(0, 19).replace('T', ' ')
    var asgnmtdata = {clid: clid,  secid: secid,stuid:this.selmember.id, retdt: retdt, oprtype: oprtype, clcd:clcd,aycd:aycd,bookid:this.selbook.bkid,
    remarks:this.isremarks,issuedt:this.dtissue,duedt:this.dtdue,
    memtype:this.selmember.usrtag,damagedfee:0,bkretstatus:this.bkretstatus
  };
    console.log('asgnmtdata-SAVE', asgnmtdata);
    this.liservice.issuebook(asgnmtdata)
    .subscribe(result => {
        console.log('ret',JSON.stringify(result));
        alert (result.message);
        this.getallissuedbooks('allcirculated');
   if(result.status=='Success')
{
  let localmodref=this.modalRef;
localmodref.close();
this.selmember={};
this.selbook={};
this.isremarks='';
this.showisuemodal=false;
//this.Refreshsummary();

}


else{


}
     
    }, error => 
    alert('error in connection')
    
    );
  }

  issuebulk()
  {
    //alert(this.selbooktitle+'-'+this.selbookid);
    var clid = 0;
    var subid = 0;
    var secid = 0;
    var retdt = '';
  
   
    let clcd=localStorage.getItem('clcd');
    let aycd=localStorage.getItem('aycd');
    console.log('selbook-SAVE', this.selmember);
    console.log('selbook-SAVE', this.selbook);
    console.log('selbook-SAVE',JSON.stringify(this.arrselbooks));
    
    var asgnmtdata = {clid: clid,  secid: secid,stuid:this.selmember.id, retdt: retdt,  clcd:clcd,aycd:aycd,memtype:this.selmember.usrtag,issuedtls:this.arrselbooks,remarks:this.isremarks
    
  };
    console.log('asgnmtdata-SAVE', asgnmtdata);
    this.liservice.bulkresbook(asgnmtdata)
    .subscribe(result => {
        console.log('ret',JSON.stringify(result));
        alert (result.message);
        //this.getallissuedbooks('allcirculated');
   if(result.status=='Success')
{
  let localmodref=this.modalRef;
localmodref.close();
this.selmember={};
this.selbook={};
this.isremarks='';
this.arrselbooks=[];
this.showisuemodal=false;
this.getlibtbkres();
//this.Refreshsummary();

}


else{


}
     
    }, error => 
    alert('error in connection')
    
    );
  }



  savelibtbkres(){

    this.liservice.savelibtbkres(this.objdet)
    .subscribe(result => {
        console.log('ret',JSON.stringify(result));
        alert (result.message);
        //this.getallissuedbooks('allcirculated');
   if(result.status=='Success')
{
  let localmodref=this.modalRef;
localmodref.close();
this.getlibtbkres();

}



     
    }, error => 
    alert('error in connection')
    
    );
  }
 


  saveissueresbook(rdet){
    console.log('rdet',JSON.stringify(rdet));
  if(confirm('Are you sure you want to issue the book ?'))
  {
    this.liservice.saveissueresbook(rdet)
    .subscribe(result => {
        console.log('ret',JSON.stringify(result));
        alert (result.message);
        //this.getallissuedbooks('allcirculated');
   if(result.status=='Success')
{
  
this.getlibtbkres();

}

    }, error => 
    alert('error in connection')
    
    );
  }
  }
  dellibtbkres(rid){

    if (confirm("Are you sure you want to remove ?"))
    {
    this.liservice.dellibtbkres(rid)
    .subscribe(result => {
        console.log('ret',JSON.stringify(result));
        alert (result.message);
        //this.getallissuedbooks('allcirculated');
  this.getlibtbkres();


     
    }, error => 
    alert('error in connection')
    
    );
  }
  }
 
  getissueddetails() {
    this.liservice.getissueddetails(this.selmember.stuid,'getstubooks')
        .subscribe(
        resultArray => {
            console.log('issueddata', resultArray);
            this.issuedetails = resultArray;
            
            
        },
        error => console.log("Error :: " + error)
        )
}


getlibtbkres() {
  this.liservice.getlibtbkres()
      .subscribe(
      resultArray => {
          console.log('issueddata', resultArray);
          this.arrresbooks = resultArray;
          
          
      },
      error => console.log("Error :: " + error)
      )
}

openedit(content,cmd,obj) {
  console.log(obj);
 this.modalOptions = {
  
  size:'lg'
  
 }
 if(cmd=='insert')
 {
   this.objdet={};
   this.objdet.rid=0;
   this.objdet.oprtype='insert';

 }
 else if(cmd=='update')
 {
   this.objdet=obj;
   this.objdet.oprtype='update';

 }
 this.modalRef=this.modalService.open(content,this.modalOptions);
   
 this.modalRef.result.then((result) => {

      // this.Asmtdetls(asid);
       this.closeResult = `Closed with: ${result}`;
   }, (reason) => {
       
   });
}

openrenretdialog(content,objdata,cmd) {
 //console.log('parseInt', parseInt('-2'));
if (parseInt(objdata.duecount)>=0 && objdata.memtype.toLowerCase()=='student')
{
this.isrenewable=true;

}

else
{
  this.isrenewable=false;
}
  let today = new Date();
        this.date1 = today;
  this.booksmodel = objdata;
  //this.model.oprtag="update";
 
  //this.booksmodel.recdt=this.liservice.getdatetoday();
  this.booksmodel.recdt= this.liservice.getdatetoday();
  this.booksmodel.reason='Satisfactory';
  this.booksmodel.oprtype='return';
  this.booksmodel.damagedfee=0;
  this.booksmodel.waveddamt=0;
  this.booksmodel.wavedlamt=0;
if(objdata.fine<0)
{
  this.booksmodel.amount=0;
}

else
{
  this.booksmodel.amount=objdata.fine;
}
  console.log('booksmodel',this.booksmodel);
  this.modalOptions = {
    backdrop:'static',
    backdropClass:'customBackdrop',
    
   
  }
  this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       
    }, (reason) => {
        
    });
}

deletefnc(id)
{
  var result = confirm("Are you sure you want to delete this?");
  if (result) {
  var clid = 0;
  var subid = 0;
  var secid = 0;
  var retdt = '';
  var oprtype = 'delete';
  let clcd=localStorage.getItem('clcd');
  let aycd=localStorage.getItem('aycd');
  
  var asgnmtdata = {clid: clid,  secid: secid,stuid:subid, retdt: retdt, oprtype: oprtype, clcd:clcd,aycd:aycd,id:id,bookid:0,
    reason:'',amount:0,remarks:'',issuedt:'',duedt:''
  };
  console.log('asgnmtdata-SAVE', asgnmtdata);
  this.liservice.issuebook(asgnmtdata)
      .subscribe(resultArray => {
          // console.log('ret-by', resultArray);
          // this.dataSource = new MatTableDataSource(resultArray);

          alert('Details Deleted');
         this.getallissuedbooks('allcirculated')
          

      }, error =>
          alert('error in connection')
      );
    }
}
SaveDetails(cmd) {
  debugger
  var clid  = 0;
  var subid = 0;
  var secid = 0;
  var retdt = this.booksmodel.recdt;
  var oprtype = cmd;
  var remarks = this.booksmodel.remarks;
  
  
 // var dbnm = this.tempdbnm;
  //var oprtag = this.model.oprtag;
  let clcd=localStorage.getItem('clcd');
  let aycd=localStorage.getItem('aycd');
  
  var asgnmtdata = {clid: clid,  secid: secid,stuid:this.booksmodel.stuid, retdt: retdt, oprtype: oprtype, clcd:clcd,aycd:aycd,id:this.booksmodel.id,bookid:this.booksmodel.bookid,
    reason:this.selfine,amount:this.booksmodel.amount,remarks:remarks,issuedt:'',duedt:'',damagedfee:this.booksmodel.damagedfee,bkretstatus:'returned',memtype:this.booksmodel.memtype,
    wavedlamt:this.booksmodel.wavedlamt,waveddamt:this.booksmodel.waveddamt
  };
  console.log('asgnmtdata-SAVE', asgnmtdata);
  this.liservice.issuebook(asgnmtdata)
      .subscribe(resultArray => {
          console.log('ret-issuebook', resultArray);
          // this.dataSource = new MatTableDataSource(resultArray);

          alert(resultArray.message);
        
         if(resultArray.status=='Success')
{
  let localmodref=this.modalRef;
localmodref.close();
//this.Refreshsummary();
this.getallissuedbooks('allcirculated')
}


else{


}

      }, error =>
          alert('error in connection')
      );
}
getallissuedbooks(oprtype) {
  this.liservice.getissueddetails(0,oprtype)
      .subscribe(
      resultArray => {
          console.log('allcirculated', resultArray);
          this.issuedetails = resultArray;
          
          
      },
      error => console.log("Error :: " + error)
      )
}

getissuealsbetdates(oprtype,bkretstatus) {
  debugger

  console.log('this.fserdt',this.fserdt);
  this.liservice.getlibissuehistory(oprtype,bkretstatus,this.fserdt,this.fserdt4)
      .subscribe(
      resultArray => {
          console.log('allcirculated', resultArray);
          this.arrhis = resultArray;
          
          
      },
      error => console.log("Error :: " + error)
      )
}
  onmemberselectEvent(item) {
    console.log('item',item);
    this.selmember=item;
    this.getissueddetails();
    // do something with selected item
  }
 
  onmemberChangeSearch(sertxt) {
    debugger
    // fetch remote data from here
    // And reassign the 'data' which is binded to 'data' property.
    if(sertxt.query.length>=3) 
    {
    this.getmemberdetails('serchmem',sertxt.query);
    }
  }
  OnHumanSelected(selitem) {
    console.log('### Trigger');
    console.log(selitem);
    // console.log(this.selitem);
    // this.selbookid=selitem.bookid;
    // this.selbooktitle=selitem.booktitle;
    
  }
  addselbook()
  {
    debugger
    // var asgnmtdata = {clid: clid,  secid: secid,stuid:this.selmember.id, retdt: retdt, oprtype: oprtype, clcd:clcd,aycd:aycd,id:this.selmember.isid,bookid:this.selbook.bkid,
    //   remarks:this.isremarks,issuedt:this.dtissue.toISOString().slice(0, 19).replace('T', ' '),duedt:this.dtdue.toISOString().slice(0, 19).replace('T', ' '),
    //   memtype:this.selmember.usrtag
    // };
    var objselbk:any={};
     objselbk.bookid=this.selbook.bkid;
     objselbk.accno=this.selbook.accno;
     objselbk.author=  this.selbook.author.replace("'"," ");
     objselbk.title=this.selbook.title;
     objselbk.remarks=this.isremarks;
     objselbk.issuedt=this.dtissue.toISOString().slice(0, 19).replace('T', ' ');
     objselbk.duedt=this.dtdue.toISOString().slice(0, 19).replace('T', ' ');
     
     this.arrselbooks.push(objselbk);
     this.selbook={};

  }

  removebook(ind)
  {
//alert(ind);
this.arrselbooks.splice(ind,1);
  }
  onbookselectEvent(item) {
    debugger
    console.log('item',item);
    this.copiesleft(item.bkid);
    
    if(item.restatus=='Available')
    {
   
      this.selbook=item;
    
    
    }
    else
    {
      this.selbook={};
    }
    // do something with selected item
  }
 
  onbookChangeSearch(sertxt) {
    // fetch remote data from here
    // And reassign the 'data' which is binded to 'data' property.
    if(sertxt.query.length>=3)
    {
    this.applybooksFilter(sertxt.query);
    }
  }
  
  onFocused(e){
    // do something when input is focused
  }
  onFocused1(e){
    // do something when input is focused
  }
  getmemberdetails(oprtype,sertxt) {
    this.liservice.getmemberdetails(oprtype,sertxt,0,0)
        .subscribe(
        resultArray => {
            console.log('members-result', resultArray);
            this.memberdetails = resultArray;
            
        },
        error => console.log("Error :: " + error)
        )
  }
  openinfo(content)
  {
  
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }

  applybooksFilter(filterValue: string) {
    // filterValue = filterValue.trim(); // Remove whitespace
    // filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
  
    
      debugger
      this.isLoadingResult = true;
    this.liservice.serchbooks(filterValue,'allbook',0)
    .subscribe(
    resultArray => {
        console.log('books-result', resultArray);
        this.bookdetails = resultArray;
      
        
    },
    error => console.log("Error :: " + error)
    )
    this.isLoadingResult = false;
  }

  copiesleft(filterValue: string) {
   
     
   this.liservice.serchbooks(filterValue,'copiesleft',0)
    .subscribe(
    resultArray => {
        console.log('copiesleft-result', resultArray);
        if(resultArray.length>0)
        {

          this.objcopies=resultArray[0];
        }
        else
        {
          this.objcopies={};
        }
        //this.bookdetails = resultArray;
      
        
    },
    error => console.log("Error :: " + error)
    )
   
  }

  searchCleared() {
    console.log('searchCleared');
    this.bookdetails = [];
  }
  opencategory(content,obj,oprtype) {
    console.log('length',this.arrselbooks.length);
    this.showisuemodal=true;
    console.log('obj',obj);
    this.oprtype=oprtype;
    this.objissued=obj;
    if (oprtype=='insert')
    {
    this.dtissue = new Date();
    //this.dtdue = today.getMonth() + '/' + today.getDate() + '/' + today.getFullYear();
    this.dtdue = new Date();
    this.dueday='0';
    this.selmember.isid='0';
  }
  else
  {
    this.selmember.isid=obj.id;
    this.selmember.id=obj.stuid;
    this.selmember.usrtag=obj.memtype;
    this.dtissue=new Date(obj.issuedt);
    this.dtdue=new Date(obj.duedt);
    this.dueday=obj.duecount;
    this.isremarks=obj.remarks;

  }
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'med'
     
     
    }
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }
  
  openeditmodal(content,obj,oprtype) {
    console.log('length',this.arrselbooks.length);
    this.showisuemodal=true;
    console.log('obj',obj);
    this.oprtype=oprtype;
    this.objissued=obj;
    if (oprtype=='insert')
    {
   // this.dtissue = this.liservice.getdatetoday();
    //this.dtdue = today.getMonth() + '/' + today.getDate() + '/' + today.getFullYear();
    //this.dtdue = this.liservice.getdatetoday();
    this.dueday='0';
    this.selmember.isid='0';
    
  }
  else
  {
    this.selmember.isid=obj.id;
    this.selmember.id=obj.stuid;
    this.selmember.usrtag=obj.memtype;
    this.dtissue=obj.issuedt;
    this.dtdue=obj.duedt;
    this.dueday=obj.duecount;
    this.isremarks=obj.remarks;
    this.bkretstatus=obj.bkretstatus;
    

  }
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'med'
     
    }
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }
  onChangetype(val)
  {

this.selres=val;
  }
  onChangefine(val)
  {
    this.selfine=val;
    //this.booksmodel.amount=0;
  }

  onChangestatus(val)
  {
    this.selstatus=val;
    //this.booksmodel.amount=0;
  }


}
